import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AnyNotesPageModule } from 'src/app/shared/modules/ui/components/any-notes-page/any-notes-page.module';
import { MyCommonModule } from '../../shared/modules/my-common/my-common.module';
import { UiModule } from '../../shared/modules/ui/ui.module';
import { VehicleAddFormComponent } from './components/vehicle-add-form/vehicle-add-form.component';
import { VehicleDetailsTabHistoryComponent } from './components/vehicle-details-tab-history/vehicle-details-tab-history.component';
import { VehicleDetailsTabLocationsComponent } from './components/vehicle-details-tab-locations/vehicle-details-tab-locations.component';
import { VehicleDetailsTabNotesComponent } from './components/vehicle-details-tab-notes/vehicle-details-tab-notes.component';
import { VehicleDetailsTabsComponent } from './components/vehicle-details-tabs/vehicle-details-tabs.component';
import { VehicleGridComponent } from './components/vehicle-grid/vehicle-grid.component';
import { VehicleListComponent } from './components/vehicle-list/vehicle-list.component';
import { VehicleBackupComponent } from './containers/vehicle-backup/vehicle-backup.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, RouterModule, MyCommonModule, UiModule, AnyNotesPageModule],
  declarations: [
    VehicleAddFormComponent,
    VehicleBackupComponent,
    VehicleListComponent,
    VehicleGridComponent,
    VehicleDetailsTabsComponent,
    VehicleDetailsTabHistoryComponent,
    VehicleDetailsTabNotesComponent,
    VehicleDetailsTabLocationsComponent,
  ],
  exports: [VehicleBackupComponent],
  entryComponents: [VehicleBackupComponent, VehicleAddFormComponent],
})
export class VehicleBackupModule {}
